import type { StateMetadata } from '../DiameterMeasurementsResolver';
import type { SceneItemKind } from '../interfaces';
import { ImagesMode, SliceType } from '../modules/images/interfaces';
import type { IBackwardCompatibilityHandler } from './CasePersistenceHub';

export class DiameterMeasurementsResolverCompatibilityHandler implements IBackwardCompatibilityHandler {
  public handleMetadata(metadata: unknown /*, version?: string*/): Promise<unknown> {
    const metaIn = metadata as Array<{
      viewDescriptor: string;
      measurements: Array<{
        descriptor: string;
        label: string;
        kind: SceneItemKind;
        phaseId: string | undefined;
        attachments: [];
      }>;
    }>;
    const metaOut: StateMetadata = metaIn.map((viewData) => ({
      viewDescriptor: viewData.viewDescriptor,
      measurements: viewData.measurements.map((measurementData) => ({
        syncSliceDescriptor: SliceType.AXIAL,
        imagesMode: ImagesMode.POLYLINE, // [chebotarev] in v1.0 here was MPR, but it was a BUG
        zoomFactor: 0.2,
        ...measurementData
      }))
    }));
    return Promise.resolve(metaOut);
  }
}
